// extracted by mini-css-extract-plugin
export default {"avatar":"Avatar_avatar__ElCGz","avatar__name":"Avatar_avatar__name__I3I94"};